<template>
  <div class="flex-y-center justify-center w-full">
    <XAttract :source="type"></XAttract>
  </div>
</template>

<script lang="ts" setup>
import XAttract from '~/components/xAttract/index.vue'
import { AttractSource } from '~/components/xAttract/constant'

const props = withDefaults(
  defineProps<{
    type: AttractSource
  }>(),
  {
    type: AttractSource.PAYMENT,
  }
)

onMounted(() => {
  if (props.type === AttractSource.PERSON_PAYMENT) {
    trackEvent(TRACK_EVENT.USER_PAYMENT_SUCCESS)
  } else if (props.type === AttractSource.TEAM_PAYMENT) {
    trackEvent(TRACK_EVENT.TEAM_PAYMENT_SUCCESS)
  }
})
</script>
